var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    _vm._b({ attrs: { role: "navigation" } }, "nav", _vm.navAttributes, false),
    [
      _c("tree-view", {
        attrs: {
          model: _vm.model,
          "root-attributes": _vm.rootAttributes,
          "render-root-child-tag": false,
          "parent-attributes": _vm.parentAttributes,
          "render-child-tag": false,
          "root-tag": "b-nav",
          "parent-tag": "b-nav-item-dropdown",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (item) {
              return _c("nav-menu-item", {
                attrs: { item: item.item, depth: item.depth },
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }